define('modules/editor/behaviours/selectable',['require','exports','module','../models/editorstate','modules/editor/views/inline_toolbar','lib/util','modules/editor/behaviours/toolbar'],function(require, exports, module) {
  "use strict";

  var EditorState = require("../models/editorstate"),
      ActiveItemState = EditorState.activeItemState,
      InlineToolbar = require("modules/editor/views/inline_toolbar"),
      util = require("lib/util"),
      ToolbarBehaviour = require("modules/editor/behaviours/toolbar");


  var doubleClickTimeout = 400;

  var selectableEvents = {
    "click": "_onClick",
    "click input": "_onClick",
    "click .hover-box": "_onClick",
    "click .ed-item-info": "_onClick"
  };

  var hideToolbarMenu = function() {
    // $(".js-trigger-toolgroup").addClass("is-menu-active");
    $(".ed-sub-toolgroup").addClass("hidden");
  };

  module.exports = {
    _selectableRender: function(func) {
      //var selected = this.data.getSelectedItem();
      var selected = ActiveItemState.getActiveItem();
      func.call(this);
      this._toggleSelected(selected && this.model === selected);
      return this;
    },
    _toggleSelected: function(isSelected) {
      //this.$el.toggleClass("item-is-edited", !!isSelected);
      // if (isSelected) {
      //   (this.$el.hasClass("ed-item-section")? this : this.parent).$el.addClass("ed-item-section-on");
      // } else {
      //   (this.$el.hasClass("ed-item-section")? this : this.parent).$el.removeClass("ed-item-section-on");
      // }
    },
    //this is only used for sections now
    _onClick: function(e){
      if(!$(e.target).hasClass("ed-item-section")) return;
      hideToolbarMenu();
      e.preventDefault();
      e.stopPropagation();
      EditorState.groupState.clear();
      EditorState.selectElement(this);
    },
    mixed: function(klass, proto) {
      proto.events = _.extend(proto.events || {}, selectableEvents);
      proto.render = _.wrap(proto.render, this._selectableRender);
      proto.initialize = _.wrap(proto.initialize || _.identity, function(init) {
        this.listenTo(this.model, "item:selected", this._toggleSelected);
        return init.apply(this, _.rest(arguments));
      });
      util.mixin(klass, ToolbarBehaviour);
    }
  };
});

